export const IM_ROUTES = {
  imRoot: "/employee/im",
  inbox: "/employee/im/inbox",
  createIncident: "/employee/im/incident/create",
  complaintDetails: "/employee/im/complaint/details",
} as const;
